<template>
  <div class="animated fadeIn" id="Hssk831-page-detail">
    <div class="card">
      <div class="card-header">
        <span>Lọc dữ liệu biểu mẫu</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="3" v-if="infoDoctor.MaTinhThanhCSKCB">
              <el-form-item label="Tỉnh/TP:" prop="ma_tinh">
                <el-select
                disabled
                  v-model="mData.dataForm.ma_tinh"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  @change="fn_changeTinh(mData.dataForm.ma_tinh, true)"
                >
                  <el-option
                    v-for="item in mData.dataDefault.dmTinh"
                    :key="item.MA_TINH"
                    :label="item.TEN_TINH"
                    :value="item.MA_TINH"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>

            <b-col md="3" v-if="infoDoctor.MaQuanHuyenCSKCB">
              <el-form-item label="Quận/Huyện:" prop="ma_huyen">
                <el-select
                disabled
                  v-model="mData.dataForm.ma_huyen"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                  @change="fn_changeHuyen(mData.dataForm.ma_tinh, mData.dataForm.ma_huyen, true)"
                >
                  <el-option
                    v-for="item in mData.dataDefault.dmHuyen"
                    :key="item.MA_QUAN"
                    :label="item.TEN_QUAN"
                    :value="item.MA_QUAN"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>

            <b-col md="3" v-if="infoDoctor.MaPhuongXaCSKCB">
              <el-form-item label="Xã/Phường:" prop="ma_xa">
                <el-select
                disabled
                  v-model="mData.dataForm.ma_xa"
                  :placeholder="aLang.c_select"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in mData.dataDefault.dmXa"
                    :key="item.MA_XA"
                    :label="item.TEN_XA"
                    :value="item.MA_XA"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Ngày theo dõi:" prop="ngay_theo_doi">
                <el-date-picker
                  type="date"
                  :format="aElement.datepicker.formatDate"
                  valueFormat="dd-MM-yyyy"
                  v-model="mData.dataForm.ngay_theo_doi"
                  :placeholder="aElement.datepicker.placeholderDate"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="submitForm()" v-ladda>Tổng hợp báo cáo</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="card" v-if="mData.showBaoCao">
      <div class="card-body p-4">
        <b-row class="mb-3">
          <b-col md="12" class="text-center bold">
            <h5 class="uppercase">Báo cáo tổng hợp theo dõi hộ gia đình</h5>
            <h5 class>(Dành cho trạm y tế xã, phường, thị trấn)</h5>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col md="6">
            <span class="form-label">Xã:</span>
            <span class="form-value" style="padding-left:15px">&nbsp;{{this.mData.dataDefault.nameXa}}</span>
          </b-col>
          <b-col md="6">
            <span class="form-label">Tổng số hộ gia đình theo dõi:</span>
            <span
              class="form-value"
              style="padding-left:15px"
            >&nbsp;{{this.handleCheckZero(this.mData.dataMain.dataReport.TongSoHGD )}}</span>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col md="12">
            <table
              border="1"
              cellspacing="0"
              cellpadding="8"
              width="100%"
              bordercolor="#777777"
              style="border-collapse: collapse;"
            >
              <tr>
                <td style="width:2cm" class="text-center">
                  <span>1</span>
                </td>
                <td style="width:10cm" class="text-right">
                  <span>Ngày theo dõi (ghi rõ ngày/tháng/năm)</span>
                </td>
                <td>
                  <span
                    style="margin-left:15px"
                  >{{this.mData.dataDefault.ngay_theo_doi}}</span>
                </td>
              </tr>

              <tr>
                <td style="width:2cm" class="text-center">
                  <span>2</span>
                </td>
                <td style="width:10cm" class="text-right">
                  <span>Số người được theo dõi trong ngày</span>
                </td>
                <td>
                  <span
                    style="margin-left:15px"
                  >{{this.handleCheckZero(this.mData.dataMain.dataReport.SoNguoiTheoDoi)}}</span>
                </td>
              </tr>

              <tr>
                <td style="width:2cm" class="text-center">
                  <span>3</span>
                </td>
                <td style="width:10cm" class="text-right">
                  <span>Số người có sức khỏe bình thường trong ngày</span>
                </td>
                <td>
                  <span
                    style="margin-left:15px"
                  >{{this.handleCheckZero(this.mData.dataMain.dataReport.SoNguoiBT )}}</span>
                </td>
              </tr>

              <tr>
                <td style="width:2cm" class="text-center">
                  <span>4</span>
                </td>
                <td style="width:10cm" class="text-right">
                  <span>Số người có triệu chứng sốt (trên 37,5'C) trong ngày</span>
                </td>
                <td>
                  <span
                    style="margin-left:15px"
                  >{{this.handleCheckZero(this.mData.dataMain.dataReport.SoNguoiSot)}}</span>
                </td>
              </tr>
              <tr>
                <td style="width:2cm" class="text-center">
                  <span>5</span>
                </td>
                <td style="width:10cm" class="text-right">
                  <span>Số người có các triệu chứng nghi ngờ khác trong ngày</span>
                </td>
                <td>
                  <span
                    style="margin-left:15px"
                  >{{this.handleCheckZero(this.mData.dataMain.dataReport.SoNguoiCoBieuHienKhac )}}</span>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col md="12" class="text-center bold">
            <h5
              class
            >Danh sách người sốt, hoặc có các triệu chứng nghi ngờ mắc bệnh trong ngày (nếu có):</h5>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col md="12">
            <table
              border="1"
              cellspacing="0"
              cellpadding="8"
              width="100%"
              bordercolor="#777777"
              style="border-collapse: collapse;"
            >
              <tr>
                <td style="width:2cm" class="text-center bold" rowspan="2">
                  <span>TT</span>
                </td>
                <td class="text-center bold" rowspan="2">
                  <span>Họ và tên</span>
                </td>
                <td class="text-center bold" rowspan="2">
                  <span>Tuổi</span>
                </td>
                <td class="text-center bold" rowspan="2">
                  <span>Giới tính</span>
                </td>
                <td class="text-center bold" rowspan="2">
                  <span>Địa chỉ (Thôn, ấp đội, tổ dân phố)</span>
                </td>
                <td class="text-center bold" rowspan="2">
                  <span>Số điện thoại</span>
                </td>
                <td class="text-center bold" colspan="2">
                  <span>Phân loại trường hợp</span>
                </td>
              </tr>
              <tr>
                <td class="text-center bold">
                  <span>Sốt (ghi rõ nhiệt độ đo được)</span>
                </td>
                <td class="text-center bold">
                  <span>Triệu chứng khác (ghi rõ triệu chứng)</span>
                </td>
              </tr>

              <tr v-for="(data,index) in mData.dataMain.dataNguoiNghiNgo" :key="index">
                <td class="text-center">{{index+1}}</td>
                <td>{{data.col_hoten}}</td>
                <td class="text-right">{{data.col_tuoi}}</td>
                <td>{{data.col_gender}}</td>
                <td>{{data.col_address}}</td>
                <td>{{data.col_sdt}}</td>
                <td class="text-right">{{data.co_than_nhiet}}</td>
                <td>{{data.col_trieu_chung_khac}}</td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import BieuMauTongHopModel from "./BieuMauTongHopModel";
// import DoiTuongTheoDoiApi from "../../../moduleApi/DoiTuongTheoDoiApi";
import KhaoSatApi from "../../../moduleApi/KhaoSatApi";
import Hssk831Api from "../../../moduleApi/Hssk831Api";
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      infoDoctor: MethodService.getCurrentUserBS(),
      mData: {
        viewMode: "create",
        moduleName: "BieuMauTongHop2A",
        dataDefault: {
          ngay_theo_doi:null,
          nameXa:null,
          dmTinh: [],
          dmHuyen: [],
          dmXa: []
        },
        dataMain: {
          dataReport: {},
          dataNguoiNghiNgo: []
        },
        dataForm: MethodService.copyObject(BieuMauTongHopModel.dataForm2B),
        validForm: MethodService.copyObject(BieuMauTongHopModel.validForm2B),
        showBaoCao: false
      }
    };
  },
  methods: {
    async takeDataXa() {
      try {
        let MaTinhThanh = this.mData.dataForm.ma_tinh;
        let MaQuanHuyen = this.mData.dataForm.ma_huyen;
        return await Hssk831Api.LoadDMPhuongXa(MaTinhThanh, MaQuanHuyen);
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    async convertNameXa(MaPhuongXa) {
      try {
        if (MaPhuongXa) {
          let res = await this.takeDataXa();
          if (res && res.data && res.data.length > 0) {
            let result = res.data.find(x => x.MA_XA == MaPhuongXa);
            return result.TEN_XA;
          } else {
            return "";
          }
        }
      } catch (e) {
        console.log(e);
        return "";
      }
    },
    handleCheckZero(value) {
      if (value || value === 0) {
        return value;
      } else return null;
    },
    async takeDataReport2A(body) {
      try {
        let res = await KhaoSatApi.getBieuMau2(body);
        return res;
      } catch (error) {
        console.log(error);
        MethodService.stopLadda();
        return [];
      }
    },
    getFullYear(date) {
      if (date) {
        date = new Date(date);
        return date.getFullYear();
      }
    },
    addColDSNguoiNghiNgo(datas) {
      if (datas && datas.length > 0) {
        return datas.map(data => {
          // triệu trứng khác
          let trieu_chung_khac = "";
          if (data.col_ho && data.col_ho === "Có") trieu_chung_khac += "Ho ,";
          if (data.col_khotho && data.col_khotho === "Có")
            trieu_chung_khac += "Khó thở ,";
          if (data.col_viemphoi && data.col_viemphoi === "Có")
            trieu_chung_khac += "Viêm Phổi ,";
          if (data.col_dauhong && data.col_dauhong === "Có")
            trieu_chung_khac += "Đau Họng ,";
          if (data.col_metmoi && data.col_metmoi === "Có")
            trieu_chung_khac += "Mệt Mỏi ,";
          data.col_trieu_chung_khac = trieu_chung_khac.slice(
            0,
            trieu_chung_khac.length - 1
          );
          // tuổi
          let tuoi = null;
          if (data.col_dob) {
            tuoi =
              Number(this.getFullYear(new Date())) -
              Number(this.getFullYear(data.col_dob));
          }
          data.col_tuoi = tuoi;

          return data;
        });
      } else {
        return [];
      }
    },
    convertDSNguoiNghiNgo(datas) {
      if (datas && datas.length > 0) {
        let mapData = datas.map(data => {
          return data.result.reduce((obj, item) => {
            return {
              ...obj,
              [item.code]: item.value
            };
          }, {});
        });
        return mapData;
      }
    },
    submitForm() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          // nameXa
          this.mData.dataDefault.nameXa = await this.convertNameXa(this.mData.dataForm.ma_xa);
          //ngay theo doi
          this.mData.dataDefault.ngay_theo_doi = this.mData.dataForm.ngay_theo_doi;
          // takeata
          let body = this.mData.dataForm;
          let { result: dataReport } = await this.takeDataReport2A(body);
          if (dataReport) {
            this.mData.dataMain.dataReport = dataReport;
            let dSNguoiNghiNgo = this.convertDSNguoiNghiNgo(
              dataReport.DSNguoiNghiNgo
            );
            this.mData.dataMain.dataNguoiNghiNgo = this.addColDSNguoiNghiNgo(
              dSNguoiNghiNgo
            );
            this.mData.showBaoCao = true;
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    handleLoadHuyenXa() {
      if (this.mData.dataForm.ma_tinh) {
        this.fn_changeTinh(this.mData.dataForm.ma_tinh, false);
        if (this.mData.dataForm.ma_huyen) {
          this.fn_changeHuyen(
            this.mData.dataForm.ma_tinh,
            this.mData.dataForm.ma_huyen,
            false
          );
        }
      }
    },
    async fn_changeTinh(MaTinhThanh, isReset) {
      if (isReset) {
        this.mData.dataForm.ma_huyen = null;
        this.mData.dataForm.ma_xa = null;
      }
      let res = await Hssk831Api.LoadDMQuanHuyen(MaTinhThanh);
      this.mData.dataDefault.dmHuyen = res.data;
    },
    async fn_changeHuyen(MaTinhThanh, MaQuanHuyen, isReset) {
      if (isReset) {
        this.mData.dataForm.ma_xa = null;
      }
      let res = await Hssk831Api.LoadDMPhuongXa(MaTinhThanh, MaQuanHuyen);
      this.mData.dataDefault.dmXa = res.data;
    },
    async fn_initDataDefault() {
      let res_LoadDMTinhThanh = await Hssk831Api.LoadDMTinhThanh();
      this.mData.dataDefault.dmTinh = res_LoadDMTinhThanh.data
        ? res_LoadDMTinhThanh.data
        : [];
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {
    this.handleLoadHuyenXa();
  }
};
</script>